import { SET_HIGHESTPAYJOBS } from "../actions/types";

const highestPay = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_HIGHESTPAYJOBS:
      return payload;
    default:
      return state;
  }
};

export default highestPay;
